import { withDependencies } from '@wix/thunderbolt-ioc'
import { IPropsStore, isViewerFragmentSymbol, Props } from '@wix/thunderbolt-symbols'
import { IModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import { name } from './symbols'
import type { SiteOverflowHandlers } from './types'

const siteOverflowFactory = (
	isViewerFragment: boolean,
	props: IPropsStore
): IModelUpdatesHandlersImplementor<SiteOverflowHandlers> => {
	return {
		featureName: name,
		handlers: {
			handleSiteOverflow: (allowSiteOverflow: boolean) => {
				if (isViewerFragment) {
					return
				}

				props.update({
					bodyClassUpdater: { disableSiteOverflow: !allowSiteOverflow },
				})
			},
		},
	}
}
export const SiteOverflow = withDependencies([isViewerFragmentSymbol, Props], siteOverflowFactory)
